//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import axios from 'axios';
import moment from 'moment';
var AchievementClient = /** @class */ (function () {
    function AchievementClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    AchievementClient.prototype.getLaundryAchievement = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Achievement/laundry";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetLaundryAchievement(_response);
        });
    };
    AchievementClient.prototype.processGetLaundryAchievement = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = Achievement.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AchievementClient.prototype.getSewingAchievement = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Achievement/sewing";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetSewingAchievement(_response);
        });
    };
    AchievementClient.prototype.processGetSewingAchievement = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = Achievement.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AchievementClient;
}());
export { AchievementClient };
var CompatibilityClient = /** @class */ (function () {
    function CompatibilityClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    CompatibilityClient.prototype.getVersions = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Compatibility/versions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetVersions(_response);
        });
    };
    CompatibilityClient.prototype.processGetVersions = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                    var item = resultData200_1[_i];
                    result200.push(item);
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CompatibilityClient.prototype.getIsLatestClientApp = function (platform, appVersion, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Compatibility/isLatestClientApp?";
        if (platform === null)
            throw new Error("The parameter 'platform' cannot be null.");
        else if (platform !== undefined)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        if (appVersion !== undefined && appVersion !== null)
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetIsLatestClientApp(_response);
        });
    };
    CompatibilityClient.prototype.processGetIsLatestClientApp = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return CompatibilityClient;
}());
export { CompatibilityClient };
var CountriesClient = /** @class */ (function () {
    function CountriesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    CountriesClient.prototype.get = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Countries";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    CountriesClient.prototype.processGet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                    var item = resultData200_2[_i];
                    result200.push(Country.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return CountriesClient;
}());
export { CountriesClient };
var CustomersClient = /** @class */ (function () {
    function CustomersClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    CustomersClient.prototype.removeExternalAuthentication = function (providerType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/removeExternalAuthentication/{providerType}";
        if (providerType === undefined || providerType === null)
            throw new Error("The parameter 'providerType' must be defined.");
        url_ = url_.replace("{providerType}", encodeURIComponent("" + providerType));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveExternalAuthentication(_response);
        });
    };
    CustomersClient.prototype.processRemoveExternalAuthentication = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.addExternalAuthentication = function (request, providerType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/addExternalAuthentication/{providerType}";
        if (providerType === undefined || providerType === null)
            throw new Error("The parameter 'providerType' must be defined.");
        url_ = url_.replace("{providerType}", encodeURIComponent("" + providerType));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddExternalAuthentication(_response);
        });
    };
    CustomersClient.prototype.processAddExternalAuthentication = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AuthenticationResponse.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 204) {
            var _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.authenticateFromExternal = function (request, providerType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/authenticateFromExternal/{providerType}";
        if (providerType === undefined || providerType === null)
            throw new Error("The parameter 'providerType' must be defined.");
        url_ = url_.replace("{providerType}", encodeURIComponent("" + providerType));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticateFromExternal(_response);
        });
    };
    CustomersClient.prototype.processAuthenticateFromExternal = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AuthenticationResponse.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.authenticate = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/authenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate(_response);
        });
    };
    CustomersClient.prototype.processAuthenticate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AuthenticationResponse.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.refreshToken = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/refreshToken";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRefreshToken(_response);
        });
    };
    CustomersClient.prototype.processRefreshToken = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AuthenticationResponse.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.import = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/import";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processImport(_response);
        });
    };
    CustomersClient.prototype.processImport = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.register = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRegister(_response);
        });
    };
    CustomersClient.prototype.processRegister = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ValidationProblemDetails.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.registerFromExternal = function (request, providerType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/registerFromExternal/{providerType}";
        if (providerType === undefined || providerType === null)
            throw new Error("The parameter 'providerType' must be defined.");
        url_ = url_.replace("{providerType}", encodeURIComponent("" + providerType));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRegisterFromExternal(_response);
        });
    };
    CustomersClient.prototype.processRegisterFromExternal = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ValidationProblemDetails.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.delete = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    CustomersClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.confirmEmail = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/confirmEmail?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processConfirmEmail(_response);
        });
    };
    CustomersClient.prototype.processConfirmEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 302) {
            var _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.confirmPhone = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/confirmPhone?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processConfirmPhone(_response);
        });
    };
    CustomersClient.prototype.processConfirmPhone = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.sendPhoneConfirmation = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/sendPhoneConfirmation";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSendPhoneConfirmation(_response);
        });
    };
    CustomersClient.prototype.processSendPhoneConfirmation = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.sendEmailConfirmation = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/sendEmailConfirmation";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSendEmailConfirmation(_response);
        });
    };
    CustomersClient.prototype.processSendEmailConfirmation = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.changeInfo = function (orderme_customer_id, request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/changeInfo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangeInfo(_response);
        });
    };
    CustomersClient.prototype.processChangeInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.changeAddresses = function (orderme_customer_id, request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/addresses";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangeAddresses(_response);
        });
    };
    CustomersClient.prototype.processChangeAddresses = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.getInfo = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/info";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetInfo(_response);
        });
    };
    CustomersClient.prototype.processGetInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CustomerLoginInfo.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 404) {
            var _responseText = response.data;
            var result404 = null;
            var resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.resetPassword = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/resetPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processResetPassword(_response);
        });
    };
    CustomersClient.prototype.processResetPassword = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.changePassword = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/changePassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangePassword(_response);
        });
    };
    CustomersClient.prototype.processChangePassword = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.changeEmail = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/changeEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangeEmail(_response);
        });
    };
    CustomersClient.prototype.processChangeEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.changePhone = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/changePhone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangePhone(_response);
        });
    };
    CustomersClient.prototype.processChangePhone = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.useCoupon = function (orderme_customer_id, couponCode, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/useCoupon?";
        if (couponCode !== undefined && couponCode !== null)
            url_ += "couponCode=" + encodeURIComponent("" + couponCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUseCoupon(_response);
        });
    };
    CustomersClient.prototype.processUseCoupon = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.contact = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/contact";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContact(_response);
        });
    };
    CustomersClient.prototype.processContact = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomersClient.prototype.getContactTargets = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Customers/contact/targets";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetContactTargets(_response);
        });
    };
    CustomersClient.prototype.processGetContactTargets = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                    var item = resultData200_3[_i];
                    result200.push(ContactTarget.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return CustomersClient;
}());
export { CustomersClient };
var DeliveryOptionsClient = /** @class */ (function () {
    function DeliveryOptionsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    DeliveryOptionsClient.prototype.get = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/DeliveryOptions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    DeliveryOptionsClient.prototype.processGet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                    var item = resultData200_4[_i];
                    result200.push(DeliveryOptions.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return DeliveryOptionsClient;
}());
export { DeliveryOptionsClient };
var FilesClient = /** @class */ (function () {
    function FilesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    FilesClient.prototype.getRules = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Files/rules";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetRules(_response);
        });
    };
    FilesClient.prototype.processGetRules = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    FilesClient.prototype.getRulesView = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Files/rules/view";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetRulesView(_response);
        });
    };
    FilesClient.prototype.processGetRulesView = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    FilesClient.prototype.getById = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Files/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetById(_response);
        });
    };
    FilesClient.prototype.processGetById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    FilesClient.prototype.getImageById = function (id, width, height, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Files/images/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (width !== undefined && width !== null)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height !== undefined && height !== null)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetImageById(_response);
        });
    };
    FilesClient.prototype.processGetImageById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    FilesClient.prototype.postFile = function (file, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Files";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPostFile(_response);
        });
    };
    FilesClient.prototype.processPostFile = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return FilesClient;
}());
export { FilesClient };
var InfoFeedsClient = /** @class */ (function () {
    function InfoFeedsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Gets info about company.
     * @return Info about company.
     */
    InfoFeedsClient.prototype.getCompanyInfo = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/InfoFeeds/company";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCompanyInfo(_response);
        });
    };
    InfoFeedsClient.prototype.processGetCompanyInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CompanyInfo.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets company description.
     * @return Company description.
     */
    InfoFeedsClient.prototype.getCompanyDescription = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/InfoFeeds/company/description";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCompanyDescription(_response);
        });
    };
    InfoFeedsClient.prototype.processGetCompanyDescription = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets company privacy policy.
     * @return Company privacy policy.
     */
    InfoFeedsClient.prototype.getCompanyPrivacyPolicy = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/InfoFeeds/company/privacypolicy";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCompanyPrivacyPolicy(_response);
        });
    };
    InfoFeedsClient.prototype.processGetCompanyPrivacyPolicy = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets company terms and conditions.
     * @return Company terms and conditions.
     */
    InfoFeedsClient.prototype.getCompanyTermsAndConditions = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/InfoFeeds/company/termsandconditions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCompanyTermsAndConditions(_response);
        });
    };
    InfoFeedsClient.prototype.processGetCompanyTermsAndConditions = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets all available info feeds.
     * @return All available info feeds.
     */
    InfoFeedsClient.prototype.getAll = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/InfoFeeds";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    InfoFeedsClient.prototype.processGetAll = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                    var item = resultData200_5[_i];
                    result200.push(InfoFeedOverview.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets all details about specific info feed.
     * @param id Id of info feed.
     * @return All available info feeds.
     */
    InfoFeedsClient.prototype.get = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/InfoFeeds/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    InfoFeedsClient.prototype.processGet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = InfoFeed.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return InfoFeedsClient;
}());
export { InfoFeedsClient };
var LinksClient = /** @class */ (function () {
    function LinksClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    LinksClient.prototype.getShorten = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Links/shorten";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetShorten(_response);
        });
    };
    LinksClient.prototype.processGetShorten = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                    var item = resultData200_6[_i];
                    result200.push(ShortDataLink.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    LinksClient.prototype.getShortenByType = function (type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Links/shorten/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetShortenByType(_response);
        });
    };
    LinksClient.prototype.processGetShortenByType = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                    var item = resultData200_7[_i];
                    result200.push(ShortDataLink.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return LinksClient;
}());
export { LinksClient };
var LocatorClient = /** @class */ (function () {
    function LocatorClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    LocatorClient.prototype.getMunicipalities = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Locator/municipalities";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetMunicipalities(_response);
        });
    };
    LocatorClient.prototype.processGetMunicipalities = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                    var item = resultData200_8[_i];
                    result200.push(Municipality.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    LocatorClient.prototype.findAddresses = function (municipality, input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Locator/addresses/{municipality}?";
        if (municipality === undefined || municipality === null)
            throw new Error("The parameter 'municipality' must be defined.");
        url_ = url_.replace("{municipality}", encodeURIComponent("" + municipality));
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFindAddresses(_response);
        });
    };
    LocatorClient.prototype.processFindAddresses = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                    var item = resultData200_9[_i];
                    result200.push(Address.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return LocatorClient;
}());
export { LocatorClient };
var OrdersClient = /** @class */ (function () {
    function OrdersClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Create new order and automatically as already paid (used only for integration with other systems).
     * @return Created order result which can be used to track order status.
     */
    OrdersClient.prototype.import = function (order, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders/import";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(order);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processImport(_response);
        });
    };
    OrdersClient.prototype.processImport = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = OrderResult.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    OrdersClient.prototype.changeImportDestination = function (destintionOffice, orderId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders/{orderId}/changeImportDestination";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(destintionOffice);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangeImportDestination(_response);
        });
    };
    OrdersClient.prototype.processChangeImportDestination = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    OrdersClient.prototype.completeImported = function (orderId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders/{orderId}/completeImported";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCompleteImported(_response);
        });
    };
    OrdersClient.prototype.processCompleteImported = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new order and automatically prepare payment. GET methods can be used to check order status.
     * @return Created order result which can be used to track order status.
     */
    OrdersClient.prototype.post = function (orderme_customer_id, order, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(order);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPost(_response);
        });
    };
    OrdersClient.prototype.processPost = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = OrderResult.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets all order for current user.
     * @param pageNumber (optional) Page number for orders to get.
     * @return All current user orders.
     */
    OrdersClient.prototype.get = function (orderme_customer_id, pageNumber, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    OrdersClient.prototype.processGet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PagedQueryResultOfOrder.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new credits order and automatically prepare payment. GET methods can be used to check order status.
     * @return Created order result which can be used to track order status.
     */
    OrdersClient.prototype.post2 = function (orderme_customer_id, order, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders/credits";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(order);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPost2(_response);
        });
    };
    OrdersClient.prototype.processPost2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = OrderResult.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Reject existing not paid order.
     * @param orderId Order id to reject.
     */
    OrdersClient.prototype.reject = function (orderme_customer_id, orderId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders/{orderId}/reject";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReject(_response);
        });
    };
    OrdersClient.prototype.processReject = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    OrdersClient.prototype.notifyKlixPayments = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders/payments/notifyKlix";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotifyKlixPayments(_response);
        });
    };
    OrdersClient.prototype.processNotifyKlixPayments = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets order payment details by specific order id.
     * @param id Order id to get payment details for.
     * @return Order payment details or 404 if such order not exist.
     */
    OrdersClient.prototype.getPayment = function (orderme_customer_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders/{id}/payment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetPayment(_response);
        });
    };
    OrdersClient.prototype.processGetPayment = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = OrderPayment.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets order by specific order id.
     * @param id Order id to get details for.
     * @return Order details or 404 if such order not exist.
     */
    OrdersClient.prototype.get2 = function (orderme_customer_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGet2(_response);
        });
    };
    OrdersClient.prototype.processGet2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = Order.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return OrdersClient;
}());
export { OrdersClient };
var ParcelLockersClient = /** @class */ (function () {
    function ParcelLockersClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ParcelLockersClient.prototype.getProviders = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/ParcelLockers/providers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProviders(_response);
        });
    };
    ParcelLockersClient.prototype.processGetProviders = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                    var item = resultData200_10[_i];
                    result200.push(ParcelLockerProvider.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets all available parcel lockers.
     * @param provider Parcel lockers provider.
     * @return All parcel lockers.
     */
    ParcelLockersClient.prototype.getAll = function (provider, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/ParcelLockers/{provider}";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    ParcelLockersClient.prototype.processGetAll = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                    var item = resultData200_11[_i];
                    result200.push(ParcelLocker.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets parcel lockers by location (4326 WGS).
     * @param provider Parcel lockers provider.
     * @param x The longitude value
     * @param y The latitude value
     * @return Parcel lockers with extra information about distances.
     */
    ParcelLockersClient.prototype.getByLocation = function (provider, x, y, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/ParcelLockers/{provider}/{x}/{y}";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetByLocation(_response);
        });
    };
    ParcelLockersClient.prototype.processGetByLocation = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                    var item = resultData200_12[_i];
                    result200.push(NearestParcelLocker.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ParcelLockersClient;
}());
export { ParcelLockersClient };
var PartnersClient = /** @class */ (function () {
    function PartnersClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Gets all available partners.
     * @return All available partners.
     */
    PartnersClient.prototype.get = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Partners";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    PartnersClient.prototype.processGet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                    var item = resultData200_13[_i];
                    result200.push(Partner.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return PartnersClient;
}());
export { PartnersClient };
var PaymentMethodsClient = /** @class */ (function () {
    function PaymentMethodsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    PaymentMethodsClient.prototype.get = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/PaymentMethods";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    PaymentMethodsClient.prototype.processGet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_14 = resultData200; _i < resultData200_14.length; _i++) {
                    var item = resultData200_14[_i];
                    result200.push(PaymentMethod.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return PaymentMethodsClient;
}());
export { PaymentMethodsClient };
var SalesPointsClient = /** @class */ (function () {
    function SalesPointsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Gets specific sales point by id.
     * @param id Id to get sales point.
     * @return Sales point.
     */
    SalesPointsClient.prototype.getById = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/SalesPoints/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetById(_response);
        });
    };
    SalesPointsClient.prototype.processGetById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = SalesPoint.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets all available sales points and wardrobes.
     * @return All sales points.
     */
    SalesPointsClient.prototype.getAll = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/SalesPoints";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    SalesPointsClient.prototype.processGetAll = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_15 = resultData200; _i < resultData200_15.length; _i++) {
                    var item = resultData200_15[_i];
                    result200.push(SalesPoint.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets sales points by type: sales point which have some type can be used for online delivery.
     * @param type Sales point type to get sales points.
     * @return Sales points which can be used for online orders.
     */
    SalesPointsClient.prototype.getByType = function (type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/SalesPoints/typified/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetByType(_response);
        });
    };
    SalesPointsClient.prototype.processGetByType = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_16 = resultData200; _i < resultData200_16.length; _i++) {
                    var item = resultData200_16[_i];
                    result200.push(SalesPoint.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets sales points by well known code.
     * @param code Sales point well known code.
     * @param type Sales point type to get sales points.
     * @return Sales points which can be used for online orders.
     */
    SalesPointsClient.prototype.getByTypeAndCode = function (code, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/SalesPoints/typified/{type}/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetByTypeAndCode(_response);
        });
    };
    SalesPointsClient.prototype.processGetByTypeAndCode = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = SalesPoint.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Gets sales points by location (4326 WGS).
     * @param x The longitude value
     * @param y The latitude value
     * @return Sales points with extra information about distances.
     */
    SalesPointsClient.prototype.getByLocation = function (x, y, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/SalesPoints/{x}/{y}";
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetByLocation(_response);
        });
    };
    SalesPointsClient.prototype.processGetByLocation = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_17 = resultData200; _i < resultData200_17.length; _i++) {
                    var item = resultData200_17[_i];
                    result200.push(NearestSalesPoint.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return SalesPointsClient;
}());
export { SalesPointsClient };
var ServicesClient = /** @class */ (function () {
    function ServicesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ServicesClient.prototype.getServiceById = function (id, orderme_customer_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Services/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetServiceById(_response);
        });
    };
    ServicesClient.prototype.processGetServiceById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ServiceItem.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ServicesClient.prototype.getCategories = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Services/categories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCategories(_response);
        });
    };
    ServicesClient.prototype.processGetCategories = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_18 = resultData200; _i < resultData200_18.length; _i++) {
                    var item = resultData200_18[_i];
                    result200.push(ServiceCategory.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ServicesClient.prototype.getCategoryGroups = function (categoryId, orderme_customer_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Services/categories/{categoryId}/groups";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCategoryGroups(_response);
        });
    };
    ServicesClient.prototype.processGetCategoryGroups = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_19 = resultData200; _i < resultData200_19.length; _i++) {
                    var item = resultData200_19[_i];
                    result200.push(ServiceGroup.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ServicesClient.prototype.getGroups = function (orderme_customer_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Services/groups";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroups(_response);
        });
    };
    ServicesClient.prototype.processGetGroups = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_20 = resultData200; _i < resultData200_20.length; _i++) {
                    var item = resultData200_20[_i];
                    result200.push(ServiceGroup.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ServicesClient.prototype.getGroupServices = function (id, orderme_customer_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Services/groups/{id}/services";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroupServices(_response);
        });
    };
    ServicesClient.prototype.processGetGroupServices = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_21 = resultData200; _i < resultData200_21.length; _i++) {
                    var item = resultData200_21[_i];
                    result200.push(ServiceItem.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ServicesClient.prototype.getServices = function (orderme_customer_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Services";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetServices(_response);
        });
    };
    ServicesClient.prototype.processGetServices = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_22 = resultData200; _i < resultData200_22.length; _i++) {
                    var item = resultData200_22[_i];
                    result200.push(ServiceItem.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ServicesClient.prototype.getServiceItems = function (orderme_customer_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Services/items";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetServiceItems(_response);
        });
    };
    ServicesClient.prototype.processGetServiceItems = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_23 = resultData200; _i < resultData200_23.length; _i++) {
                    var item = resultData200_23[_i];
                    result200.push(ServiceItem.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ServicesClient.prototype.getCreditServices = function (orderme_customer_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Services/credits";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "orderme-customer-id": orderme_customer_id !== undefined && orderme_customer_id !== null ? "" + orderme_customer_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCreditServices(_response);
        });
    };
    ServicesClient.prototype.processGetCreditServices = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_24 = resultData200; _i < resultData200_24.length; _i++) {
                    var item = resultData200_24[_i];
                    result200.push(CreditServiceItem.fromJS(item, _mappings));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ServicesClient;
}());
export { ServicesClient };
var SettingsClient = /** @class */ (function () {
    function SettingsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    SettingsClient.prototype.get = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1.11/Settings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    SettingsClient.prototype.processGet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GeneralSettings.fromJS(resultData200, _mappings);
            return Promise.resolve(result200);
        }
        else if (status === 409) {
            var _responseText = response.data;
            var result409 = null;
            var resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return SettingsClient;
}());
export { SettingsClient };
var Achievement = /** @class */ (function () {
    function Achievement(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Achievement.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.stores = _data["stores"];
            this.smartDrobes = _data["smartDrobes"];
            this.customers = _data["customers"];
            this.items = _data["items"];
            this.companyAgeInYears = _data["companyAgeInYears"];
        }
    };
    Achievement.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Achievement);
    };
    Achievement.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["stores"] = this.stores;
        data["smartDrobes"] = this.smartDrobes;
        data["customers"] = this.customers;
        data["items"] = this.items;
        data["companyAgeInYears"] = this.companyAgeInYears;
        return data;
    };
    return Achievement;
}());
export { Achievement };
var ProblemDetails = /** @class */ (function () {
    function ProblemDetails(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProblemDetails.prototype.init = function (_data, _mappings) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    };
    ProblemDetails.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ProblemDetails);
    };
    ProblemDetails.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    };
    return ProblemDetails;
}());
export { ProblemDetails };
export var ClientPlatformType;
(function (ClientPlatformType) {
    ClientPlatformType["Web"] = "Web";
    ClientPlatformType["Android"] = "Android";
    ClientPlatformType["Apple"] = "Apple";
})(ClientPlatformType || (ClientPlatformType = {}));
var Country = /** @class */ (function () {
    function Country(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Country.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.phonePrefix = _data["phonePrefix"];
        }
    };
    Country.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Country);
    };
    Country.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phonePrefix"] = this.phonePrefix;
        return data;
    };
    return Country;
}());
export { Country };
export var ExternalAuthenticationType;
(function (ExternalAuthenticationType) {
    ExternalAuthenticationType["Google"] = "Google";
    ExternalAuthenticationType["Facebook"] = "Facebook";
    ExternalAuthenticationType["Apple"] = "Apple";
})(ExternalAuthenticationType || (ExternalAuthenticationType = {}));
var AuthenticationResponse = /** @class */ (function () {
    function AuthenticationResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticationResponse.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    };
    AuthenticationResponse.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, AuthenticationResponse);
    };
    AuthenticationResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    };
    return AuthenticationResponse;
}());
export { AuthenticationResponse };
var ExternalAuthenticationRequest = /** @class */ (function () {
    function ExternalAuthenticationRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalAuthenticationRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.code = _data["code"];
            this.state = _data["state"];
        }
    };
    ExternalAuthenticationRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ExternalAuthenticationRequest);
    };
    ExternalAuthenticationRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["code"] = this.code;
        data["state"] = this.state;
        return data;
    };
    return ExternalAuthenticationRequest;
}());
export { ExternalAuthenticationRequest };
var AuthenticationRequest = /** @class */ (function () {
    function AuthenticationRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticationRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.input = _data["input"];
            this.password = _data["password"];
        }
    };
    AuthenticationRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, AuthenticationRequest);
    };
    AuthenticationRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["input"] = this.input;
        data["password"] = this.password;
        return data;
    };
    return AuthenticationRequest;
}());
export { AuthenticationRequest };
var RefreshTokenRequest = /** @class */ (function () {
    function RefreshTokenRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RefreshTokenRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    };
    RefreshTokenRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, RefreshTokenRequest);
    };
    RefreshTokenRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    };
    return RefreshTokenRequest;
}());
export { RefreshTokenRequest };
var ImportCustomerRequest = /** @class */ (function () {
    function ImportCustomerRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportCustomerRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
        }
    };
    ImportCustomerRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ImportCustomerRequest);
    };
    ImportCustomerRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        return data;
    };
    return ImportCustomerRequest;
}());
export { ImportCustomerRequest };
var HttpValidationProblemDetails = /** @class */ (function (_super) {
    __extends(HttpValidationProblemDetails, _super);
    function HttpValidationProblemDetails(data) {
        return _super.call(this, data) || this;
    }
    HttpValidationProblemDetails.prototype.init = function (_data, _mappings) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {};
                for (var key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        this.errors[key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    };
    HttpValidationProblemDetails.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, HttpValidationProblemDetails);
    };
    HttpValidationProblemDetails.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (var key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    data["errors"][key] = this.errors[key];
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return HttpValidationProblemDetails;
}(ProblemDetails));
export { HttpValidationProblemDetails };
var ValidationProblemDetails = /** @class */ (function (_super) {
    __extends(ValidationProblemDetails, _super);
    function ValidationProblemDetails(data) {
        return _super.call(this, data) || this;
    }
    ValidationProblemDetails.prototype.init = function (_data, _mappings) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {};
                for (var key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        this.errors[key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    };
    ValidationProblemDetails.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ValidationProblemDetails);
    };
    ValidationProblemDetails.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (var key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    data["errors"][key] = this.errors[key];
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return ValidationProblemDetails;
}(HttpValidationProblemDetails));
export { ValidationProblemDetails };
var RegistrationRequest = /** @class */ (function () {
    function RegistrationRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegistrationRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.password = _data["password"];
            this.gender = _data["gender"];
            this.communicationAgreed = _data["communicationAgreed"];
            this.rulesAcceptedAgreed = _data["rulesAcceptedAgreed"];
            this.birthDate = _data["birthDate"] ? moment.parseZone(_data["birthDate"].toString()) : undefined;
        }
    };
    RegistrationRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, RegistrationRequest);
    };
    RegistrationRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["password"] = this.password;
        data["gender"] = this.gender;
        data["communicationAgreed"] = this.communicationAgreed;
        data["rulesAcceptedAgreed"] = this.rulesAcceptedAgreed;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString(true) : undefined;
        return data;
    };
    return RegistrationRequest;
}());
export { RegistrationRequest };
export var GenderType;
(function (GenderType) {
    GenderType["Male"] = "Male";
    GenderType["Female"] = "Female";
})(GenderType || (GenderType = {}));
var ExternalRegistrationRequest = /** @class */ (function () {
    function ExternalRegistrationRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalRegistrationRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.communicationAgreed = _data["communicationAgreed"];
            this.rulesAcceptedAgreed = _data["rulesAcceptedAgreed"];
            this.birthDate = _data["birthDate"] ? moment.parseZone(_data["birthDate"].toString()) : undefined;
            this.credentials = _data["credentials"];
            this.code = _data["code"];
            this.state = _data["state"];
        }
    };
    ExternalRegistrationRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ExternalRegistrationRequest);
    };
    ExternalRegistrationRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["communicationAgreed"] = this.communicationAgreed;
        data["rulesAcceptedAgreed"] = this.rulesAcceptedAgreed;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString(true) : undefined;
        data["credentials"] = this.credentials;
        data["code"] = this.code;
        data["state"] = this.state;
        return data;
    };
    return ExternalRegistrationRequest;
}());
export { ExternalRegistrationRequest };
var UpdateInfoRequest = /** @class */ (function () {
    function UpdateInfoRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateInfoRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? moment.parseZone(_data["birthDate"].toString()) : undefined;
            this.communicationAgreed = _data["communicationAgreed"];
        }
    };
    UpdateInfoRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateInfoRequest);
    };
    UpdateInfoRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString(true) : undefined;
        data["communicationAgreed"] = this.communicationAgreed;
        return data;
    };
    return UpdateInfoRequest;
}());
export { UpdateInfoRequest };
var UpdateAddressesRequest = /** @class */ (function () {
    function UpdateAddressesRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateAddressesRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [];
                for (var _i = 0, _a = _data["addresses"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.addresses.push(CustomerAddress.fromJS(item, _mappings));
                }
            }
        }
    };
    UpdateAddressesRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateAddressesRequest);
    };
    UpdateAddressesRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (var _i = 0, _a = this.addresses; _i < _a.length; _i++) {
                var item = _a[_i];
                data["addresses"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateAddressesRequest;
}());
export { UpdateAddressesRequest };
var CustomerAddress = /** @class */ (function () {
    function CustomerAddress(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomerAddress.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.address = _data["address"];
            this.apartmentNumber = _data["apartmentNumber"];
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
        }
    };
    CustomerAddress.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CustomerAddress);
    };
    CustomerAddress.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["apartmentNumber"] = this.apartmentNumber;
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        return data;
    };
    return CustomerAddress;
}());
export { CustomerAddress };
var CustomerLoginInfo = /** @class */ (function () {
    function CustomerLoginInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.customers = [];
        }
    }
    CustomerLoginInfo.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.phoneConfirmed = _data["phoneConfirmed"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.mustChangePassword = _data["mustChangePassword"];
            this.isLinkedWithGoogle = _data["isLinkedWithGoogle"];
            this.isLinkedWithFacebook = _data["isLinkedWithFacebook"];
            this.isLinkedWithApple = _data["isLinkedWithApple"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [];
                for (var _i = 0, _a = _data["customers"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customers.push(CustomerInfo.fromJS(item, _mappings));
                }
            }
        }
    };
    CustomerLoginInfo.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CustomerLoginInfo);
    };
    CustomerLoginInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["phoneConfirmed"] = this.phoneConfirmed;
        data["emailConfirmed"] = this.emailConfirmed;
        data["mustChangePassword"] = this.mustChangePassword;
        data["isLinkedWithGoogle"] = this.isLinkedWithGoogle;
        data["isLinkedWithFacebook"] = this.isLinkedWithFacebook;
        data["isLinkedWithApple"] = this.isLinkedWithApple;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (var _i = 0, _a = this.customers; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customers"].push(item.toJSON());
            }
        }
        return data;
    };
    return CustomerLoginInfo;
}());
export { CustomerLoginInfo };
var CustomerInfo = /** @class */ (function () {
    function CustomerInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomerInfo.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.gender = _data["gender"];
            this.communicationAgreedOn = _data["communicationAgreedOn"] ? moment.parseZone(_data["communicationAgreedOn"].toString()) : undefined;
            this.rulesAcceptedOn = _data["rulesAcceptedOn"] ? moment.parseZone(_data["rulesAcceptedOn"].toString()) : undefined;
            this.birthDate = _data["birthDate"] ? moment.parseZone(_data["birthDate"].toString()) : undefined;
            this.ordersUsingAddressesOnly = _data["ordersUsingAddressesOnly"];
            this.credit = _data["credit"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [];
                for (var _i = 0, _a = _data["addresses"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.addresses.push(CustomerAddressInfo.fromJS(item, _mappings));
                }
            }
        }
    };
    CustomerInfo.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CustomerInfo);
    };
    CustomerInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["gender"] = this.gender;
        data["communicationAgreedOn"] = this.communicationAgreedOn ? this.communicationAgreedOn.toISOString(true) : undefined;
        data["rulesAcceptedOn"] = this.rulesAcceptedOn ? this.rulesAcceptedOn.toISOString(true) : undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString(true) : undefined;
        data["ordersUsingAddressesOnly"] = this.ordersUsingAddressesOnly;
        data["credit"] = this.credit;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (var _i = 0, _a = this.addresses; _i < _a.length; _i++) {
                var item = _a[_i];
                data["addresses"].push(item.toJSON());
            }
        }
        return data;
    };
    return CustomerInfo;
}());
export { CustomerInfo };
var CustomerAddressInfo = /** @class */ (function () {
    function CustomerAddressInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.address = new CustomerAddress();
        }
    }
    CustomerAddressInfo.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.address = _data["address"] ? CustomerAddress.fromJS(_data["address"], _mappings) : new CustomerAddress();
            this.isValid = _data["isValid"];
        }
    };
    CustomerAddressInfo.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CustomerAddressInfo);
    };
    CustomerAddressInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["isValid"] = this.isValid;
        return data;
    };
    return CustomerAddressInfo;
}());
export { CustomerAddressInfo };
var ResetPasswordRequest = /** @class */ (function () {
    function ResetPasswordRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    };
    ResetPasswordRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ResetPasswordRequest);
    };
    ResetPasswordRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    };
    return ResetPasswordRequest;
}());
export { ResetPasswordRequest };
var ChangePasswordRequest = /** @class */ (function () {
    function ChangePasswordRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangePasswordRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    };
    ChangePasswordRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ChangePasswordRequest);
    };
    ChangePasswordRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    };
    return ChangePasswordRequest;
}());
export { ChangePasswordRequest };
var ChangeEmailRequest = /** @class */ (function () {
    function ChangeEmailRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangeEmailRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.email = _data["email"];
        }
    };
    ChangeEmailRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ChangeEmailRequest);
    };
    ChangeEmailRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    };
    return ChangeEmailRequest;
}());
export { ChangeEmailRequest };
var ChangePhoneRequest = /** @class */ (function () {
    function ChangePhoneRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangePhoneRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.phone = _data["phone"];
        }
    };
    ChangePhoneRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ChangePhoneRequest);
    };
    ChangePhoneRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        return data;
    };
    return ChangePhoneRequest;
}());
export { ChangePhoneRequest };
var ContactRequest = /** @class */ (function () {
    function ContactRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ContactRequest.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.targetId = _data["targetId"];
            this.content = _data["content"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.orderNo = _data["orderNo"];
            if (Array.isArray(_data["attachmentIds"])) {
                this.attachmentIds = [];
                for (var _i = 0, _a = _data["attachmentIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.attachmentIds.push(item);
                }
            }
        }
    };
    ContactRequest.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ContactRequest);
    };
    ContactRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["targetId"] = this.targetId;
        data["content"] = this.content;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["orderNo"] = this.orderNo;
        if (Array.isArray(this.attachmentIds)) {
            data["attachmentIds"] = [];
            for (var _i = 0, _a = this.attachmentIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["attachmentIds"].push(item);
            }
        }
        return data;
    };
    return ContactRequest;
}());
export { ContactRequest };
export var ContactTargetType;
(function (ContactTargetType) {
    ContactTargetType["Questions"] = "Questions";
    ContactTargetType["Claims"] = "Claims";
    ContactTargetType["Business"] = "Business";
})(ContactTargetType || (ContactTargetType = {}));
var ContactTarget = /** @class */ (function () {
    function ContactTarget(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ContactTarget.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    };
    ContactTarget.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ContactTarget);
    };
    ContactTarget.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    };
    return ContactTarget;
}());
export { ContactTarget };
var DeliveryOptions = /** @class */ (function () {
    function DeliveryOptions(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryOptions.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    };
    DeliveryOptions.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, DeliveryOptions);
    };
    DeliveryOptions.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    };
    return DeliveryOptions;
}());
export { DeliveryOptions };
export var DeliveryType;
(function (DeliveryType) {
    DeliveryType["SalesPoint"] = "SalesPoint";
    DeliveryType["Wardrobe"] = "Wardrobe";
    DeliveryType["Address"] = "Address";
    DeliveryType["ForeignLocker"] = "ForeignLocker";
})(DeliveryType || (DeliveryType = {}));
var CompanyInfo = /** @class */ (function () {
    function CompanyInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyInfo.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.description = _data["description"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.privacyPolicy = _data["privacyPolicy"];
        }
    };
    CompanyInfo.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CompanyInfo);
    };
    CompanyInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["termsAndConditions"] = this.termsAndConditions;
        data["privacyPolicy"] = this.privacyPolicy;
        return data;
    };
    return CompanyInfo;
}());
export { CompanyInfo };
var InfoFeedOverview = /** @class */ (function () {
    function InfoFeedOverview(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InfoFeedOverview.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.heading = _data["heading"];
            this.imageId = _data["imageId"];
        }
    };
    InfoFeedOverview.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, InfoFeedOverview);
    };
    InfoFeedOverview.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["heading"] = this.heading;
        data["imageId"] = this.imageId;
        return data;
    };
    return InfoFeedOverview;
}());
export { InfoFeedOverview };
var InfoFeed = /** @class */ (function (_super) {
    __extends(InfoFeed, _super);
    function InfoFeed(data) {
        return _super.call(this, data) || this;
    }
    InfoFeed.prototype.init = function (_data, _mappings) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.description = _data["description"];
        }
    };
    InfoFeed.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, InfoFeed);
    };
    InfoFeed.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return InfoFeed;
}(InfoFeedOverview));
export { InfoFeed };
var ShortDataLink = /** @class */ (function () {
    function ShortDataLink(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShortDataLink.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.dataId = _data["dataId"];
            this.type = _data["type"];
        }
    };
    ShortDataLink.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ShortDataLink);
    };
    ShortDataLink.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataId"] = this.dataId;
        data["type"] = this.type;
        return data;
    };
    return ShortDataLink;
}());
export { ShortDataLink };
export var ShortDataLinkType;
(function (ShortDataLinkType) {
    ShortDataLinkType["ServiceGroup"] = "ServiceGroup";
    ShortDataLinkType["ServiceCategory"] = "ServiceCategory";
    ShortDataLinkType["InfoFeed"] = "InfoFeed";
    ShortDataLinkType["Service"] = "Service";
    ShortDataLinkType["ServicePhysicalItem"] = "ServicePhysicalItem";
})(ShortDataLinkType || (ShortDataLinkType = {}));
var Municipality = /** @class */ (function () {
    function Municipality(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Municipality.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    };
    Municipality.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Municipality);
    };
    Municipality.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    };
    return Municipality;
}());
export { Municipality };
var Address = /** @class */ (function () {
    function Address(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Address.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.fullAddress = _data["fullAddress"];
            this.municipality = _data["municipality"];
            this.location = _data["location"] ? Point.fromJS(_data["location"], _mappings) : undefined;
        }
    };
    Address.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Address);
    };
    Address.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fullAddress"] = this.fullAddress;
        data["municipality"] = this.municipality;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        return data;
    };
    return Address;
}());
export { Address };
var Point = /** @class */ (function () {
    function Point(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Point.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    };
    Point.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Point);
    };
    Point.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    };
    return Point;
}());
export { Point };
var OrderResult = /** @class */ (function () {
    function OrderResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderResult.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
        }
    };
    OrderResult.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, OrderResult);
    };
    OrderResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        return data;
    };
    return OrderResult;
}());
export { OrderResult };
var ImportOrder = /** @class */ (function () {
    function ImportOrder(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }
    ImportOrder.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.no = _data["no"];
            this.customer = _data["customer"] ? ImportOrderCustomer.fromJS(_data["customer"], _mappings) : undefined;
            this.destination = _data["destination"] ? ImportOrderDestination.fromJS(_data["destination"], _mappings) : undefined;
            this.note = _data["note"];
            this.tag = _data["tag"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ImportOrderItem.fromJS(item, _mappings));
                }
            }
        }
    };
    ImportOrder.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ImportOrder);
    };
    ImportOrder.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : undefined;
        data["note"] = this.note;
        data["tag"] = this.tag;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ImportOrder;
}());
export { ImportOrder };
var ImportOrderCustomer = /** @class */ (function () {
    function ImportOrderCustomer(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportOrderCustomer.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.phone = _data["phone"];
        }
    };
    ImportOrderCustomer.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ImportOrderCustomer);
    };
    ImportOrderCustomer.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        return data;
    };
    return ImportOrderCustomer;
}());
export { ImportOrderCustomer };
var ImportOrderDestination = /** @class */ (function () {
    function ImportOrderDestination(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportOrderDestination.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.office = _data["office"] ? ImportDestinationOffice.fromJS(_data["office"], _mappings) : undefined;
            this.address = _data["address"] ? DestinationAddress.fromJS(_data["address"], _mappings) : undefined;
        }
    };
    ImportOrderDestination.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ImportOrderDestination);
    };
    ImportOrderDestination.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["office"] = this.office ? this.office.toJSON() : undefined;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        return data;
    };
    return ImportOrderDestination;
}());
export { ImportOrderDestination };
var ImportDestinationOffice = /** @class */ (function () {
    function ImportDestinationOffice(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportDestinationOffice.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
        }
    };
    ImportDestinationOffice.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ImportDestinationOffice);
    };
    ImportDestinationOffice.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        return data;
    };
    return ImportDestinationOffice;
}());
export { ImportDestinationOffice };
export var ImportOfficeType;
(function (ImportOfficeType) {
    ImportOfficeType["Sewing"] = "Sewing";
    ImportOfficeType["Laundry"] = "Laundry";
    ImportOfficeType["SmartWardrobe"] = "SmartWardrobe";
    ImportOfficeType["Wardrobe"] = "Wardrobe";
})(ImportOfficeType || (ImportOfficeType = {}));
var DestinationAddress = /** @class */ (function () {
    function DestinationAddress(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DestinationAddress.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.fullAddress = _data["fullAddress"];
            this.apartmentNumber = _data["apartmentNumber"];
        }
    };
    DestinationAddress.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, DestinationAddress);
    };
    DestinationAddress.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fullAddress"] = this.fullAddress;
        data["apartmentNumber"] = this.apartmentNumber;
        return data;
    };
    return DestinationAddress;
}());
export { DestinationAddress };
var ImportOrderItem = /** @class */ (function () {
    function ImportOrderItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportOrderItem.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.discount = _data["discount"];
            this.count = _data["count"];
        }
    };
    ImportOrderItem.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ImportOrderItem);
    };
    ImportOrderItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["price"] = this.price;
        data["discount"] = this.discount;
        data["count"] = this.count;
        return data;
    };
    return ImportOrderItem;
}());
export { ImportOrderItem };
var NewOrder = /** @class */ (function () {
    function NewOrder(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.services = [];
        }
    }
    NewOrder.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.paymentMethodId = _data["paymentMethodId"];
            this.destination = _data["destination"] ? OrderDestination.fromJS(_data["destination"], _mappings) : undefined;
            this.note = _data["note"];
            this.creditsUsed = _data["creditsUsed"];
            this.expectedPrice = _data["expectedPrice"];
            if (Array.isArray(_data["services"])) {
                this.services = [];
                for (var _i = 0, _a = _data["services"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.services.push(NewServiceItem.fromJS(item, _mappings));
                }
            }
        }
    };
    NewOrder.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, NewOrder);
    };
    NewOrder.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodId"] = this.paymentMethodId;
        data["destination"] = this.destination ? this.destination.toJSON() : undefined;
        data["note"] = this.note;
        data["creditsUsed"] = this.creditsUsed;
        data["expectedPrice"] = this.expectedPrice;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (var _i = 0, _a = this.services; _i < _a.length; _i++) {
                var item = _a[_i];
                data["services"].push(item.toJSON());
            }
        }
        return data;
    };
    return NewOrder;
}());
export { NewOrder };
/** Class represents possible order destinations. Only one of possible destinations must be set. */
var OrderDestination = /** @class */ (function () {
    function OrderDestination(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDestination.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.knownId = _data["knownId"];
            this.address = _data["address"] ? DestinationAddress.fromJS(_data["address"], _mappings) : undefined;
            this.parcelLocker = _data["parcelLocker"] ? ForeignLockerDestination.fromJS(_data["parcelLocker"], _mappings) : undefined;
        }
    };
    OrderDestination.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, OrderDestination);
    };
    OrderDestination.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["knownId"] = this.knownId;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["parcelLocker"] = this.parcelLocker ? this.parcelLocker.toJSON() : undefined;
        return data;
    };
    return OrderDestination;
}());
export { OrderDestination };
var ForeignLockerDestination = /** @class */ (function () {
    function ForeignLockerDestination(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ForeignLockerDestination.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.provider = _data["provider"];
            this.lockerId = _data["lockerId"];
        }
    };
    ForeignLockerDestination.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ForeignLockerDestination);
    };
    ForeignLockerDestination.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["lockerId"] = this.lockerId;
        return data;
    };
    return ForeignLockerDestination;
}());
export { ForeignLockerDestination };
var NewServiceItem = /** @class */ (function () {
    function NewServiceItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NewServiceItem.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
        }
    };
    NewServiceItem.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, NewServiceItem);
    };
    NewServiceItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        return data;
    };
    return NewServiceItem;
}());
export { NewServiceItem };
var NewCreditsOrder = /** @class */ (function () {
    function NewCreditsOrder(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NewCreditsOrder.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.paymentMethodId = _data["paymentMethodId"];
            this.expectedPrice = _data["expectedPrice"];
            this.expectedCredits = _data["expectedCredits"];
        }
    };
    NewCreditsOrder.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, NewCreditsOrder);
    };
    NewCreditsOrder.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodId"] = this.paymentMethodId;
        data["expectedPrice"] = this.expectedPrice;
        data["expectedCredits"] = this.expectedCredits;
        return data;
    };
    return NewCreditsOrder;
}());
export { NewCreditsOrder };
var PagedQueryResultOfOrder = /** @class */ (function () {
    function PagedQueryResultOfOrder(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedQueryResultOfOrder.prototype.init = function (_data, _mappings) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(Order.fromJS(item, _mappings));
                }
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PagedQueryResultOfOrder.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, PagedQueryResultOfOrder);
    };
    PagedQueryResultOfOrder.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PagedQueryResultOfOrder;
}());
export { PagedQueryResultOfOrder };
var Order = /** @class */ (function () {
    function Order(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Order.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.returnDate = _data["returnDate"] ? moment.parseZone(_data["returnDate"].toString()) : undefined;
            this.status = _data["status"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalPrice = _data["totalPrice"];
            this.creditsUsed = _data["creditsUsed"];
            this.destination = _data["destination"] ? OrderDestination.fromJS(_data["destination"], _mappings) : undefined;
            this.payment = _data["payment"] ? OrderPayment.fromJS(_data["payment"], _mappings) : undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrderItem.fromJS(item, _mappings));
                }
            }
            this.note = _data["note"];
        }
    };
    Order.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Order);
    };
    Order.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString(true) : undefined;
        data["status"] = this.status;
        data["totalDiscount"] = this.totalDiscount;
        data["totalPrice"] = this.totalPrice;
        data["creditsUsed"] = this.creditsUsed;
        data["destination"] = this.destination ? this.destination.toJSON() : undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["note"] = this.note;
        return data;
    };
    return Order;
}());
export { Order };
/** Represents order status. Old obsolete values removed from v1.4: PreparingPayment, WaitingForPaymentPreparation */
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["WaitingForPayment"] = "WaitingForPayment";
    OrderStatus["Processing"] = "Processing";
    OrderStatus["Ready"] = "Ready";
    OrderStatus["Accepted"] = "Accepted";
    OrderStatus["Completed"] = "Completed";
    OrderStatus["Cancelled"] = "Cancelled";
    OrderStatus["AcceptedBySalesPoint"] = "AcceptedBySalesPoint";
    OrderStatus["PickedUpByCourier"] = "PickedUpByCourier";
    OrderStatus["ReadyToPickUpByCourier"] = "ReadyToPickUpByCourier";
})(OrderStatus || (OrderStatus = {}));
var OrderPayment = /** @class */ (function () {
    function OrderPayment(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderPayment.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.method = _data["method"];
            this.paidOn = _data["paidOn"] ? moment.parseZone(_data["paidOn"].toString()) : undefined;
            this.checkoutUrl = _data["checkoutUrl"];
            this.isActive = _data["isActive"];
        }
    };
    OrderPayment.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, OrderPayment);
    };
    OrderPayment.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        data["paidOn"] = this.paidOn ? this.paidOn.toISOString(true) : undefined;
        data["checkoutUrl"] = this.checkoutUrl;
        data["isActive"] = this.isActive;
        return data;
    };
    return OrderPayment;
}());
export { OrderPayment };
var OrderItem = /** @class */ (function () {
    function OrderItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderItem.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.discount = _data["discount"];
            this.amount = _data["amount"];
            this.amountUnit = _data["amountUnit"];
            this.serviceId = _data["serviceId"];
            this.isItem = _data["isItem"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [];
                for (var _i = 0, _a = _data["comments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.comments.push(OrderComment.fromJS(item, _mappings));
                }
            }
        }
    };
    OrderItem.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, OrderItem);
    };
    OrderItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["discount"] = this.discount;
        data["amount"] = this.amount;
        data["amountUnit"] = this.amountUnit;
        data["serviceId"] = this.serviceId;
        data["isItem"] = this.isItem;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (var _i = 0, _a = this.comments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["comments"].push(item.toJSON());
            }
        }
        return data;
    };
    return OrderItem;
}());
export { OrderItem };
export var AmountUnitType;
(function (AmountUnitType) {
    AmountUnitType["Count"] = "Count";
    AmountUnitType["Weight"] = "Weight";
    AmountUnitType["Area"] = "Area";
})(AmountUnitType || (AmountUnitType = {}));
var OrderComment = /** @class */ (function () {
    function OrderComment(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderComment.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.comment = _data["comment"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
        }
    };
    OrderComment.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, OrderComment);
    };
    OrderComment.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        return data;
    };
    return OrderComment;
}());
export { OrderComment };
var ParcelLockerProvider = /** @class */ (function () {
    function ParcelLockerProvider(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ParcelLockerProvider.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
        }
    };
    ParcelLockerProvider.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ParcelLockerProvider);
    };
    ParcelLockerProvider.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        return data;
    };
    return ParcelLockerProvider;
}());
export { ParcelLockerProvider };
var ParcelLocker = /** @class */ (function () {
    function ParcelLocker(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ParcelLocker.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.location = _data["location"] ? Point.fromJS(_data["location"], _mappings) : undefined;
        }
    };
    ParcelLocker.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ParcelLocker);
    };
    ParcelLocker.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        data["address"] = this.address;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        return data;
    };
    return ParcelLocker;
}());
export { ParcelLocker };
var NearestParcelLocker = /** @class */ (function () {
    function NearestParcelLocker(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NearestParcelLocker.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.value = _data["value"] ? ParcelLocker.fromJS(_data["value"], _mappings) : undefined;
            this.distanceInMeters = _data["distanceInMeters"];
            this.distanceInDegrees = _data["distanceInDegrees"];
        }
    };
    NearestParcelLocker.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, NearestParcelLocker);
    };
    NearestParcelLocker.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        data["distanceInMeters"] = this.distanceInMeters;
        data["distanceInDegrees"] = this.distanceInDegrees;
        return data;
    };
    return NearestParcelLocker;
}());
export { NearestParcelLocker };
var Partner = /** @class */ (function () {
    function Partner(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Partner.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.webAddress = _data["webAddress"];
        }
    };
    Partner.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Partner);
    };
    Partner.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["webAddress"] = this.webAddress;
        return data;
    };
    return Partner;
}());
export { Partner };
var PaymentMethod = /** @class */ (function () {
    function PaymentMethod(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.logoUrls = [];
        }
    }
    PaymentMethod.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["logoUrls"])) {
                this.logoUrls = [];
                for (var _i = 0, _a = _data["logoUrls"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.logoUrls.push(item);
                }
            }
        }
    };
    PaymentMethod.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, PaymentMethod);
    };
    PaymentMethod.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.logoUrls)) {
            data["logoUrls"] = [];
            for (var _i = 0, _a = this.logoUrls; _i < _a.length; _i++) {
                var item = _a[_i];
                data["logoUrls"].push(item);
            }
        }
        return data;
    };
    return PaymentMethod;
}());
export { PaymentMethod };
export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Other"] = "Other";
    PaymentMethodType["Card"] = "Card";
    PaymentMethodType["GooglePay"] = "GooglePay";
    PaymentMethodType["ApplyPay"] = "ApplyPay";
})(PaymentMethodType || (PaymentMethodType = {}));
var SalesPoint = /** @class */ (function () {
    function SalesPoint(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SalesPoint.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.city = _data["city"];
            this.type = _data["type"];
            this.info = _data["info"];
            this.workingHoursInfo = _data["workingHoursInfo"];
            this.logoId = _data["logoId"];
            this.location = _data["location"] ? Point.fromJS(_data["location"], _mappings) : undefined;
            if (Array.isArray(_data["serviceStaff"])) {
                this.serviceStaff = [];
                for (var _i = 0, _a = _data["serviceStaff"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.serviceStaff.push(item);
                }
            }
            if (Array.isArray(_data["offices"])) {
                this.offices = [];
                for (var _b = 0, _c = _data["offices"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.offices.push(SalesPointOffice.fromJS(item, _mappings));
                }
            }
            this.isCodeRequired = _data["isCodeRequired"];
        }
    };
    SalesPoint.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, SalesPoint);
    };
    SalesPoint.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["city"] = this.city;
        data["type"] = this.type;
        data["info"] = this.info;
        data["workingHoursInfo"] = this.workingHoursInfo;
        data["logoId"] = this.logoId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        if (Array.isArray(this.serviceStaff)) {
            data["serviceStaff"] = [];
            for (var _i = 0, _a = this.serviceStaff; _i < _a.length; _i++) {
                var item = _a[_i];
                data["serviceStaff"].push(item);
            }
        }
        if (Array.isArray(this.offices)) {
            data["offices"] = [];
            for (var _b = 0, _c = this.offices; _b < _c.length; _b++) {
                var item = _c[_b];
                data["offices"].push(item.toJSON());
            }
        }
        data["isCodeRequired"] = this.isCodeRequired;
        return data;
    };
    return SalesPoint;
}());
export { SalesPoint };
export var SalesPointType;
(function (SalesPointType) {
    SalesPointType["SalesPoint"] = "SalesPoint";
    SalesPointType["Wardrobe"] = "Wardrobe";
})(SalesPointType || (SalesPointType = {}));
var SalesPointOffice = /** @class */ (function () {
    function SalesPointOffice(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SalesPointOffice.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.type = _data["type"];
            this.logoId = _data["logoId"];
        }
    };
    SalesPointOffice.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, SalesPointOffice);
    };
    SalesPointOffice.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["logoId"] = this.logoId;
        return data;
    };
    return SalesPointOffice;
}());
export { SalesPointOffice };
export var OfficeType;
(function (OfficeType) {
    OfficeType["Sewing"] = "Sewing";
    OfficeType["Laundry"] = "Laundry";
})(OfficeType || (OfficeType = {}));
var NearestSalesPoint = /** @class */ (function () {
    function NearestSalesPoint(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NearestSalesPoint.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.value = _data["value"] ? SalesPoint.fromJS(_data["value"], _mappings) : undefined;
            this.distanceInMeters = _data["distanceInMeters"];
            this.distanceInDegrees = _data["distanceInDegrees"];
        }
    };
    NearestSalesPoint.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, NearestSalesPoint);
    };
    NearestSalesPoint.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        data["distanceInMeters"] = this.distanceInMeters;
        data["distanceInDegrees"] = this.distanceInDegrees;
        return data;
    };
    return NearestSalesPoint;
}());
export { NearestSalesPoint };
var ServiceItem = /** @class */ (function () {
    function ServiceItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceItem.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [];
                for (var _i = 0, _a = _data["prices"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.prices.push(PriceByAmount.fromJS(item, _mappings));
                }
            }
            this.originalPrice = _data["originalPrice"];
            this.discount = _data["discount"];
            this.description = _data["description"];
            this.logoId = _data["logoId"];
            this.isItem = _data["isItem"];
            this.canBePaidWithCredits = _data["canBePaidWithCredits"];
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (var _b = 0, _c = _data["images"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.images.push(ImageItem.fromJS(item, _mappings));
                }
            }
        }
    };
    ServiceItem.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ServiceItem);
    };
    ServiceItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (var _i = 0, _a = this.prices; _i < _a.length; _i++) {
                var item = _a[_i];
                data["prices"].push(item.toJSON());
            }
        }
        data["originalPrice"] = this.originalPrice;
        data["discount"] = this.discount;
        data["description"] = this.description;
        data["logoId"] = this.logoId;
        data["isItem"] = this.isItem;
        data["canBePaidWithCredits"] = this.canBePaidWithCredits;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _b = 0, _c = this.images; _b < _c.length; _b++) {
                var item = _c[_b];
                data["images"].push(item.toJSON());
            }
        }
        return data;
    };
    return ServiceItem;
}());
export { ServiceItem };
var PriceByAmount = /** @class */ (function () {
    function PriceByAmount(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PriceByAmount.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.amount = _data["amount"];
            this.price = _data["price"];
        }
    };
    PriceByAmount.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, PriceByAmount);
    };
    PriceByAmount.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["price"] = this.price;
        return data;
    };
    return PriceByAmount;
}());
export { PriceByAmount };
var ImageItem = /** @class */ (function () {
    function ImageItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImageItem.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.order = _data["order"];
        }
    };
    ImageItem.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ImageItem);
    };
    ImageItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["order"] = this.order;
        return data;
    };
    return ImageItem;
}());
export { ImageItem };
var ServiceCategory = /** @class */ (function () {
    function ServiceCategory(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceCategory.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.itemsOnly = _data["itemsOnly"];
        }
    };
    ServiceCategory.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ServiceCategory);
    };
    ServiceCategory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["itemsOnly"] = this.itemsOnly;
        return data;
    };
    return ServiceCategory;
}());
export { ServiceCategory };
var ServiceGroup = /** @class */ (function () {
    function ServiceGroup(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceGroup.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.pricesStartFrom = _data["pricesStartFrom"];
            this.maxDiscount = _data["maxDiscount"];
            this.logoId = _data["logoId"];
            this.numberOfServices = _data["numberOfServices"];
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (var _i = 0, _a = _data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(ImageItem.fromJS(item, _mappings));
                }
            }
        }
    };
    ServiceGroup.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ServiceGroup);
    };
    ServiceGroup.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["pricesStartFrom"] = this.pricesStartFrom;
        data["maxDiscount"] = this.maxDiscount;
        data["logoId"] = this.logoId;
        data["numberOfServices"] = this.numberOfServices;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        return data;
    };
    return ServiceGroup;
}());
export { ServiceGroup };
var CreditServiceItem = /** @class */ (function () {
    function CreditServiceItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreditServiceItem.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.credits = _data["credits"];
        }
    };
    CreditServiceItem.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CreditServiceItem);
    };
    CreditServiceItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["credits"] = this.credits;
        return data;
    };
    return CreditServiceItem;
}());
export { CreditServiceItem };
var GeneralSettings = /** @class */ (function () {
    function GeneralSettings(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.authentication = new AuthenticationSettings();
            this.orders = new OrderSettings();
        }
    }
    GeneralSettings.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.authentication = _data["authentication"] ? AuthenticationSettings.fromJS(_data["authentication"], _mappings) : new AuthenticationSettings();
            this.orders = _data["orders"] ? OrderSettings.fromJS(_data["orders"], _mappings) : new OrderSettings();
        }
    };
    GeneralSettings.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, GeneralSettings);
    };
    GeneralSettings.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["authentication"] = this.authentication ? this.authentication.toJSON() : undefined;
        data["orders"] = this.orders ? this.orders.toJSON() : undefined;
        return data;
    };
    return GeneralSettings;
}());
export { GeneralSettings };
var AuthenticationSettings = /** @class */ (function () {
    function AuthenticationSettings(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticationSettings.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.googleClientId = _data["googleClientId"];
            this.facebookClientId = _data["facebookClientId"];
            this.appleClientId = _data["appleClientId"];
        }
    };
    AuthenticationSettings.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, AuthenticationSettings);
    };
    AuthenticationSettings.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["googleClientId"] = this.googleClientId;
        data["facebookClientId"] = this.facebookClientId;
        data["appleClientId"] = this.appleClientId;
        return data;
    };
    return AuthenticationSettings;
}());
export { AuthenticationSettings };
var OrderSettings = /** @class */ (function () {
    function OrderSettings(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderSettings.prototype.init = function (_data, _mappings) {
        if (_data) {
            this.deliveryServiceId = _data["deliveryServiceId"];
            this.freeDeliverFrom = _data["freeDeliverFrom"];
            this.parcelLockerDeliveryServiceId = _data["parcelLockerDeliveryServiceId"];
            this.parcelLockerFreeDeliverFrom = _data["parcelLockerFreeDeliverFrom"];
            this.wardrobeDeliveryServiceId = _data["wardrobeDeliveryServiceId"];
            this.wardrobeFreeDeliverFrom = _data["wardrobeFreeDeliverFrom"];
        }
    };
    OrderSettings.fromJS = function (data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, OrderSettings);
    };
    OrderSettings.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryServiceId"] = this.deliveryServiceId;
        data["freeDeliverFrom"] = this.freeDeliverFrom;
        data["parcelLockerDeliveryServiceId"] = this.parcelLockerDeliveryServiceId;
        data["parcelLockerFreeDeliverFrom"] = this.parcelLockerFreeDeliverFrom;
        data["wardrobeDeliveryServiceId"] = this.wardrobeDeliveryServiceId;
        data["wardrobeFreeDeliverFrom"] = this.wardrobeFreeDeliverFrom;
        return data;
    };
    return OrderSettings;
}());
export { OrderSettings };
function jsonParse(json, reviver) {
    json = JSON.parse(json, reviver);
    var byid = {};
    var refs = [];
    json = (function recurse(obj, prop, parent) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        if ("$ref" in obj) {
            var ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        }
        else if ("$id" in obj) {
            var id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        if (Array.isArray(obj)) {
            obj = obj.map(function (v, i) { return recurse(v, i, obj); });
        }
        else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }
        return obj;
    })(json);
    for (var i = 0; i < refs.length; i++) {
        var ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }
    return json;
}
function createInstance(data, mappings, type) {
    if (!mappings)
        mappings = [];
    if (!data)
        return null;
    var mappingIndexName = "__mappingIndex";
    if (data[mappingIndexName])
        return mappings[data[mappingIndexName]].target;
    data[mappingIndexName] = mappings.length;
    var result = new type();
    mappings.push({ source: data, target: result });
    result.init(data, mappings);
    return result;
}
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
export { ApiException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
